// @flow

"use strict";

import OuterDIContainer from "../../model/outer/outer-di-container";

export default class OuterOkwave_pcDIContainer extends OuterDIContainer {
  constructor(){
    super();
  }

  static getInstance(): OuterOkwave_pcDIContainer{
    const container = new OuterOkwave_pcDIContainer();
    OuterOkwave_pcDIContainer.getInstance = function(): OuterOkwave_pcDIContainer{
      return container;
    };

    return container;
  }


  /**
   * iframeParentDivはMediaに貼られるタグのDiv
   */
  // getURLFunction(window: Window, iframeParentDiv: HTMLElement): string{
  //   import URLUtil from "../../util/url-util";
  //   return URLUtil.fixedEncodeURIComponent(window.location.href);
  // };

}



// WEBPACK FOOTER //
// ./src/js/placement/okwave_pc/okwave_pc-outer-frame.js